define('bizzabo/models/Partners',['bizzabo/bzapi', 'bizzabo/models/SyncedCollection', 'bizzabo/models/Partner'], function(BZAPI, SyncedCollection, Partner) {

    var Partners = SyncedCollection.extend({

        model : Partner,

        sync : function(method, model, options) {
            var thisEventId = this.eventId;
            if (method == 'read') {
                BZAPI.getPartnersList(thisEventId, function(getSponsorsListData) {
                    BZAPI.getPartnersAnalytics(thisEventId, function(getPartnersAnalyticsData) {
                        options.success && options.success(model.mergeAnalyticsIntoPartnerModels(getSponsorsListData, getPartnersAnalyticsData), options);
                        model.shouldFetch = false;
                    }, options.error);
                }, options.error);
            } else if (method == 'update') {
                BZAPI.updatePartnersList(thisEventId, model.removeAnalyticsFromModels(model.toJSON()), function(data) {
                    options.success && options.success(data, options);
                    model.assimilateJson(data);
                    model.shouldFetch = false;
                    model.wasChanged = false;
                }, options.error);
            }
        },

        initialize : function() {
            this.wasChanged= false,
                this.partnerErrors = {};
            this.listenTo(this, 'validated', this.partnerValidated);
            this.listenTo(this, 'remove', this.removedPartner);
            this.listenTo(this, 'reset', this.removedAllPartners);
        },

        partnerValidated : function(isValid, model, errors) {
            if (isValid) {
                model && model.cid && this.partnerErrors[model.cid] && delete this.partnerErrors[model.cid];
            } else {
                this.partnerErrors[model.cid] = errors;
            }

            var numberOfInvalidPartners = _.size(this.partnerErrors);
            this.trigger('partnersValidated', (numberOfInvalidPartners <= 0), this, this.partnerErrors);
        },

        removedPartner : function(model) {
            this.partnerValidated(true, model);
        },

        removedAllPartners : function() {
            this.partnerErrors = {};
            this.partnerValidated(true);
        },

        mergeAnalyticsIntoPartnerModels : function(partnersListJSON, partnersAnalyticsJSON) {
            for (var partnerIndex in partnersListJSON) {
                var partnerJSON = partnersListJSON[partnerIndex];
                for (var analyticsIndex in partnersAnalyticsJSON) {
                    var analyticsJSON = partnersAnalyticsJSON[analyticsIndex];
                    if (analyticsJSON["event-partner-id"] == partnerJSON["id"]) {
                        partnerJSON["analytics"] = analyticsJSON;
                        break;
                    }
                }
            }
            return partnersListJSON;
        },

        removeAnalyticsFromModels : function(partnersListJSON) {
            for (var partnerIndex in partnersListJSON) {
                var partnerJSON = partnersListJSON[partnerIndex];
                delete partnerJSON["analytics"];
            }
            return partnersListJSON;
        },

        save : function(options) {
            var emptyFunction = function() {
            };
            options = options || {};
            options.error = options.error || emptyFunction;
            this.sync('update', this, options);
        },

        validate : function() {
            var invalidAttributes = undefined;
            this.each(function(partner) {
                partner.wasEdited = true;
                var invalidPartnerAttrs = partner.validate(null, {
                    forceUpdate : false
                });
                if (invalidPartnerAttrs) {
                    invalidAttributes = invalidAttributes || {};
                    invalidAttributes[partner.cid] = invalidPartnerAttrs;
                }
            });
            return invalidAttributes;
        }

    });

    return Partners;
});

